import React from "react";
import { useNavigate } from "react-router-dom";

import "./PageThree.less";

const PageThree = () => {
    const navigate = useNavigate();
    return (
        <div className="pageThree_bg">
            <div className="pageThree_Port_bg">
                <div className="textDiv">
                    <div className="pageThree_Port_text">Get in Touch with Us !</div>
                    <div className="pageThree_Port_text2">Looking to integrate HTML5 Games?</div>
                </div>
                <div className="pageThree_Port_button" onClick={() => {
                    // navigate("/contact-us");
                    window.open('/contact-us','_blank')
                    // window.scrollTo(0, 0);
                }}>CONTACT US</div>
            </div>
        </div>
    );
};

export default PageThree;
